import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';

const rootDialogStyle = {
  width: '720px',
  padding: '1em'
};

const buttonContainerStyle = {
  float: 'right'
};

const ConfirmRemoveResolution = ({
  closeAuditResolutionDialog,
  selectedAuditResolutionOptionId,
  selectedAuditReasonId,
  selectedAuditReasonIsResolvedValue,
  resolveAuditReason,
  hydrateEncounterAuditReasons
}) => {
  return (
    <div style={rootDialogStyle}>
      {/* title */}
      <div>
        <h3 style={{ textAlign: 'center' }}>
          Audit Resolution - Remove Resolution
        </h3>
      </div>

      <div>
        <p>Are you sure you want to remove the selected resolution reason?</p>
      </div>

      {/* cancel & ok buttons */}
      <div style={buttonContainerStyle}>
        <button onClick={closeAuditResolutionDialog}>
          Cancel
        </button>

        <button
          onClick={() => {
            resolveAuditReason(
              Number.parseInt(selectedAuditReasonId),
              Number.parseInt(selectedAuditResolutionOptionId),
              !selectedAuditReasonIsResolvedValue, // opposite of current value
              hydrateEncounterAuditReasons
            );
          }}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

ConfirmRemoveResolution.propTypes = {
  closeAuditResolutionDialog: PropTypes.func.isRequired,
  selectedAuditResolutionOptionId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  selectedAuditReasonId: PropTypes.number.isRequired,
  selectedAuditReasonIsResolvedValue: PropTypes.bool.isRequired,
  hydrateEncounterAuditReasons: PropTypes.func.isRequired,
  resolveAuditReason: PropTypes.func.isRequired
};

const ConfirmAddResolution = ({
  closeAuditResolutionDialog,
  selectedAuditResolutionOptionId,
  selectedAuditReasonId,
  selectedAuditReasonIsResolvedValue,
  resolveAuditReason,
  hydrateEncounterAuditReasons,
  selectAuditResolutionOption,
  auditResolutionOptions
}) => {
  return (
    <div style={rootDialogStyle}>
      {/* title */}
      <div>
        <h3 style={{ textAlign: 'center' }}>
          Audit Resolution - Add Resolution
        </h3>
      </div>

      {/* select audit resolution option */}
      <div style={{ textAlign: 'center' }}>
        <select
          onChange={selectAuditResolutionOption}
          value={selectedAuditResolutionOptionId}
        >
          <option value="-1">Choose an Audit Resolution Option</option>
          {
            auditResolutionOptions.map(x => (
              <option
                key={x.value}
                value={x.value}
              >
                {x.label}
              </option>
            ))
          }
        </select>
      </div>

      {/* cancel & ok buttons */}
      <div style={buttonContainerStyle}>
        <button onClick={closeAuditResolutionDialog}>
          Cancel
        </button>

        <button
        disabled={
          selectedAuditResolutionOptionId === "-1"
          || selectedAuditResolutionOptionId === -1
        }
          onClick={() => {
            resolveAuditReason(
              Number.parseInt(selectedAuditReasonId),
              Number.parseInt(selectedAuditResolutionOptionId),
              !selectedAuditReasonIsResolvedValue, // opposite of current value
              hydrateEncounterAuditReasons
            );
          }}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

ConfirmAddResolution.propTypes = {
  selectAuditResolutionOption: PropTypes.func.isRequired,
  auditResolutionOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  closeAuditResolutionDialog: PropTypes.func.isRequired,
  selectedAuditResolutionOptionId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  selectedAuditReasonId: PropTypes.number.isRequired,
  selectedAuditReasonIsResolvedValue: PropTypes.bool.isRequired,
  hydrateEncounterAuditReasons: PropTypes.func.isRequired,
  resolveAuditReason: PropTypes.func.isRequired
};

const AuditResolutionDialog = ({
  isOpen,
  resolveAuditReason,
  closeAuditResolutionDialog,
  selectedAuditReasonId,
  selectedAuditReasonIsResolvedValue,
  auditResolutionOptions,
  selectAuditResolutionOption,
  selectedAuditResolutionOptionId,
  hydrateEncounterAuditReasons
}) => {
  return (
    <Dialog
      open={isOpen}
      maxWidth="lg"
      disableBackdropClick
      disableEscapeKeyDown
    >
      {
        selectedAuditReasonIsResolvedValue === true
          ? <ConfirmRemoveResolution
              closeAuditResolutionDialog={closeAuditResolutionDialog}
              selectedAuditResolutionOptionId={selectedAuditResolutionOptionId}
              selectedAuditReasonId={selectedAuditReasonId}
              selectedAuditReasonIsResolvedValue={
                selectedAuditReasonIsResolvedValue
              }
              resolveAuditReason={resolveAuditReason}
              hydrateEncounterAuditReasons={hydrateEncounterAuditReasons}
            />
          :
            <ConfirmAddResolution
              closeAuditResolutionDialog={closeAuditResolutionDialog}
              selectedAuditResolutionOptionId={selectedAuditResolutionOptionId}
              selectedAuditReasonId={selectedAuditReasonId}
              selectedAuditReasonIsResolvedValue={
                selectedAuditReasonIsResolvedValue
              }
              resolveAuditReason={resolveAuditReason}
              hydrateEncounterAuditReasons={hydrateEncounterAuditReasons}
              selectAuditResolutionOption={selectAuditResolutionOption}
              auditResolutionOptions={auditResolutionOptions}
            />
      }
    </Dialog>
  );
};

AuditResolutionDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  resolveAuditReason: PropTypes.func.isRequired,
  closeAuditResolutionDialog: PropTypes.func.isRequired,
  selectedAuditReasonId: PropTypes.number.isRequired,
  selectedAuditReasonIsResolvedValue: PropTypes.bool.isRequired,
  auditResolutionOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  selectAuditResolutionOption: PropTypes.func.isRequired,
  selectedAuditResolutionOptionId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  hydrateEncounterAuditReasons: PropTypes.func.isRequired
};

export default AuditResolutionDialog;
